import React, { Component } from 'react';
import Card from '../../../components/CardNew/index';
import { MUNDIALPLAYERS, URLRIBBONMATCHES, URLVCARDJPLAYER, URLVCARDDIRECTOR, COACH } from '../../../components/RibbonNew/constants';
import GeneralRibbonUtils from '../../../components/RibbonNew/GeneralRibbonUtils';
import Utils from '../../../utils/Utils';
import { CARRUSELESVCARD, SELECCIONADOS, SELECCIONADOSRELACIONADOS, JUGADORESRELACIONADOS, VCARDPARTIDO, VCARDEQUIPO, VCARDJUGADOR } from '../../utls/constants';
import './_styles.scss';

export default class RibbonSoccerPlayer extends Component {
  constructor(props) {
    super(props);
    this.carruselTitle = props.carruselTitle;
    this.items = props.items;
    this.badgesUserType = props.badgesUserType;
    this.ignoreSeenLast = props.ignoreSeenLast;
    this.focusSettings = props.focusSettings;
    this.ribbonId = props.ribbonId;
    this.focusHandler = props.focusHandler;
    this.onClickHandler = props.onClickHandler;
    this.setMetricsEvent = props.setMetricsEvent;
    this.hideInnerTitle = props.hideInnerTitle;
    this.keyDownHandler = props.keyDownHandler;
    this.className = props.className;
    this.title = props.title;
    this.ribbonIndex = props.index;
    this.typeRender = props.typeRender ? props.typeRender : null;
    this.dataUpdateMetrics = props.dataUpdateMetrics;
    this.visibleItems = props.visibleItems;
    this.idTeam = props.idTeam;
    this.typeTeam = props.typeTeam || null;
    this.ribbonName = props.ribbonName;
  }

  clickHandler(data) {
    this.onClickHandler && this.onClickHandler(data);
  }

  async componentDidMount() {
    window.SpatialNavigation.makeFocusable();
  }

  componentDidUpdate() {
    window.SpatialNavigation.makeFocusable();
  }

  handleOnClick(node_item, location){
    const myLocation = location.pathname.split("/");
    let action = SELECCIONADOS;
    let category = CARRUSELESVCARD
    switch (myLocation[2]) {
      case VCARDPARTIDO:
        action = `${SELECCIONADOS} ${node_item.nationality.toLowerCase()}`;
        break;
      case VCARDEQUIPO:
        action = `${SELECCIONADOS}`;
        break;
      case VCARDJUGADOR:
        action = `${SELECCIONADOSRELACIONADOS}`;
        category = `${JUGADORESRELACIONADOS}`;
        break;
      default:
        action = `${SELECCIONADOSRELACIONADOS}`;
        category = `${JUGADORESRELACIONADOS}`;
        break;
    }

    Utils.sendMetric(this.props, action,  `${node_item.name}`, category);
  }

  render() {
    return (
      <div className="ribbon-items ribbon-players" id={`${MUNDIALPLAYERS}`}>
        {this.visibleItems.map((node, index) => {
          const node_item = node.item;
          const key = Math.random() * 10;
          const uri = node_item.role === COACH ? `${URLVCARDDIRECTOR}${this.props.idTeam}/${node_item.id}` : `${URLVCARDJPLAYER}${this.props.idTeam}/${node_item.id}`;
          const dataMetricsRibbon = {
            node_item,
            node_location: `${URLRIBBONMATCHES}${node_item.id}`,
            ribbon_title: this.carruselTitle,
          };

          let cardProps = {
              unFocusHandler: this.unFocusHandler,
              id: this.typeTeam ? `${node_item.id}-${this.typeTeam}` : node_item.id,
              key: key,
              ribbonIndex: this.ribbonIndex,
              ignoreSeenLast: this.ignoreSeenLast,
              data: node_item,
              group_id: node_item.id,
              type: MUNDIALPLAYERS,
              typeRender: '',
              dataMetric: {
                carruselTitle: this.carruselTitle,
                cardPosition: GeneralRibbonUtils.getPositionMundial(
                  this.items,
                  node_item.id
                ),
              },
              focusable: node.nodeFocusable === undefined ? index===0 : node.nodeFocusable,
              focusRight: `#${this.ribbonId} ${this.focusSettings.selector}`,
              focusLeft: `#${this.ribbonId} ${this.focusSettings.selector}`,
              focusHandler: this.focusHandler,
              setMetricsEvent: this.setMetricsEvent,
              href: uri,
              hideInnerTitle: this.hideInnerTitle,
              ribbonName: this.ribbonName,
              onClick: () => {
                this.handleOnClick(node_item, this.props.location);
                this.dataUpdateMetrics(dataMetricsRibbon);
              }
          };
          return <Card {...cardProps} />;
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mundial/RibbonTypes/RibbonsPlayers/index.jsx